import React from "react";

export default function LoadingIndicator() {
  return (
    <img src='/assets/loading.gif' />
  );
}
